import { render, staticRenderFns } from "./ComentarioAvaliacao.vue?vue&type=template&id=4bda264e"
import script from "./ComentarioAvaliacao.vue?vue&type=script&lang=js"
export * from "./ComentarioAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports